import DatePicker from '@amzn/meridian/date-picker';
import { addDays, format } from 'date-fns';
import React from 'react';

export interface CommonDatePickerProps {
  label: string;
  value: string;
  onChange: (date: string) => void;
  error?: boolean;
}

/**
 * Custom Datepicker to add commonly used settings like presets
 * @constructor
 */
export const CustomDatePicker = ({ label, value, onChange, error }: CommonDatePickerProps) => {
  const formatIso = (date: Date) => format(date, 'yyyy-MM-dd');
  const yesterday = formatIso(addDays(new Date(), -1));
  const today = formatIso(new Date());
  const tomorrow = formatIso(addDays(new Date(), 1));
  const sevenDaysAgo = formatIso(addDays(new Date(), -7));
  const sevenDaysFromNow = formatIso(addDays(new Date(), 7));

  const presets = [
    { label: 'A week ago', value: sevenDaysAgo },
    { label: 'Yesterday', value: yesterday },
    { label: 'Today', value: today },
    { label: 'Tomorrow', value: tomorrow },
    { label: 'Next week', value: sevenDaysFromNow },
  ];

  return <DatePicker presets={presets} label={label} value={value} onChange={onChange} error={error} />;
};
